export class FilterWithDropdownController {
    static $inject = ['$rootScope'];
    constructor($rootScope) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.chips = [];
        this.chipsInternal = [];
        this.onOpen = () => {
            this.chipsInternal = this.chips;
            this.applyButtonDisabled = true;
        };
        this.onClose = () => {
            this.chips = this.chipsInternal;
        };
        this.applyFilter = () => {
            this.chipsInternal = this.chips;
            this.$rootScope.$broadcast('ToggleDropdownItem');
            this.$rootScope.$broadcast('angucomplete-alt:clearInput');
            this.handleFilter({ $items: this.chips });
        };
        this.onChangeItem = (event) => {
            this.applyButtonDisabled = false;
            const chips = event.detail.data;
            this.chips = chips;
        };
        this.clearFilter = () => {
            this.applyButtonDisabled = false;
            this.chips = [];
        };
    }
}
FilterWithDropdownController.$inject = ['$rootScope'];
